"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _FiatDepositFormComponent = _interopRequireDefault(require("./FiatDepositFormComponent"));
var _depositActions = require("../../../../redux/actions/depositActions");
var _modalActions = require("../../../../redux/actions/modalActions");
var _kycLevelsSelectors = require("../../../../redux/selectors/kycLevelsSelectors");
var _sidePaneActions = require("../../../../redux/actions/sidePaneActions");
var _positionActions = require("../../../../redux/actions/positionActions");
var _createFiatDepositHelper = require("../../../../helpers/createFiatDepositHelper");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    disableDeposit = _kycVerificationLevel.disableDeposit;
  return {
    disableDeposit: disableDeposit,
    depositInfo: state.deposit,
    products: state.apexCore.product,
    allowTransfer: _config["default"].global.allowTransfer
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectPosition: function selectPosition(productId) {
      return dispatch((0, _positionActions.selectPosition)(productId));
    },
    confirmDeposit: _depositActions.createDepositTicket,
    verificationOnClick: function verificationOnClick() {
      return dispatch((0, _sidePaneActions.closeSidePane)());
    },
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch((0, _depositActions.fetchAllProductDepositTemplates)(productId));
    },
    selectDepositTemplate: function selectDepositTemplate(ProductId, AccountProviderId) {
      return dispatch((0, _depositActions.fetchProductDepositTemplate)(ProductId, AccountProviderId));
    }
  };
};
var FiatDepositForm = (0, _reduxForm.reduxForm)({
  form: 'createFiatDeposit',
  onSubmit: function onSubmit(payload, dispatch, _ref) {
    var _ref$depositInfo = _ref.depositInfo,
      template = _ref$depositInfo.template,
      templateInfo = _ref$depositInfo.templateInfo,
      registeredFields = _ref.registeredFields;
    return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_FIAT_DEPOSIT, {
      payload: (0, _createFiatDepositHelper.validateDepositTicketPayload)(payload, registeredFields),
      template: template,
      templateInfo: templateInfo
    }));
  }
})(_FiatDepositFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FiatDepositForm);